// extracted by css-extract-rspack-plugin
export default {"cls1":"ReferenceEvaluationPage-cls1_l3X","cls2":"ReferenceEvaluationPage-cls2_DS1 ReferenceEvaluationPage-cls1_l3X"};